import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 🧩 Variables Overview

Variables in **HawkClient** are powerful placeholders that let you define dynamic, reusable values to simplify request building and workspace management. They help you avoid hardcoding values like API endpoints, tokens, or user IDs, and allow smoother transitions between environments.

HawkClient supports four types of variables, each with its own scope and purpose:

- **Global Variables** – Available across the entire workspace, including all collections and requests. Best used for constants or fallback values.
- **Collection Variables** – Scoped to a specific collection and available to all requests within it. Useful for collection-level settings like authentication tokens or API versions.
- **Environment Variables** – Workspace-level variables grouped into environments (e.g., dev, staging, prod). Ideal for managing differences in base URLs, tokens, etc., across different deployment environments.
- **Request Variables** – Defined per request. These have the highest precedence and are useful for temporary values or for setting data dynamically using pre-request or post-response scripts.

You can use any variable by wrapping its name in double curly braces, like **{{baseUrl}}**.

## 🔄 Variable Precedence

Variable precedence determines which variable is used when multiple variables share the same name across different scopes. HawkClient resolves variables in the following order:

1. **Request Variables** – highest priority
2. **Environment Variables**
3. **Collection Variables**
4. **Global Variables** – lowest priority

This means if a variable named **token** exists in both request and environment scopes, the request-level value will be used.

Variables are stored as JSON files within your workspace folder, making them easy to version control and share across teams.
`;

const VariablesOverview = () => {
    return (
        <MarkDownRenderer
            title="Variables Overview"
            markDownText={markdownContent}
        />
    );
};

export default VariablesOverview;
